import * as HistoryModule from "Modules/HistoryModule";
import * as React from "react";
import {withTranslation} from "react-i18next";
import {
  DateComponent,
  DistanceComponent,
  DurationComponent
} from "components/Map/CarDetails/Composites/_CompositesHelpers";

export const HistoryRideElement = (props: {
  ride: HistoryModule.Types.CarRideSummaryDto;
  parking: HistoryModule.Types.CarParkingDto;
  onClick: Function;
  t?: Function;
  error: boolean
}) => {
  const {ride, error, t} = props;
  return (
    <div className={`ride-history__single ${error ? 'ride-history__single--error' : ''}`}
         onClick={() => props.onClick()}>
      <div className="ride-history__summary">
        <img src="/images/icons/ride_icon.svg" width="13"/>
        <DateComponent date={ride.startDate} type={'blue'}/>
        <DurationComponent durationSeconds={ride.durationSeconds}/>
        <DistanceComponent mileage={ride.distanceKilometers}/>
      </div>
      <div className="ride-history__details">
        <div className="ride-history__details--half">
          <p className="font-lighter font-grey-light">{t('startDate')}:</p>
          <DateComponent date={ride.startDate} includeHours alignLeft/>
          <p className="font-xs font-grey-light">{ride.startAddress}</p>
        </div>
        <div className="ride-history__details--half">
          <p className="font-lighter font-grey-light">{t('endDate')}:</p>
          <DateComponent date={ride.endDate} includeHours alignLeft/>
          <p className="font-xs font-grey-light">{ride.endAddress}</p>
        </div>
      </div>
    </div>

  );
};

export default withTranslation(['carDetails', 'forms'])(HistoryRideElement as React.ComponentType<any>);



// WEBPACK FOOTER //
// ./src/components/Map/CarDetails/Components/HistoryRideElement.Component.tsx